import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

/**
 * Column Text & Image Section
 * Handles animations for cards with images and text
 */
class ColumnTextImage {
  private section: HTMLElement;
  private header: HTMLElement | null;
  private cards: NodeListOf<HTMLElement>;

  constructor(section: HTMLElement) {
    this.section = section;
    this.header = section.querySelector('.c-column-text-image__header');
    this.cards = section.querySelectorAll('[data-card]');

    this.init();
  }

  private init(): void {
    this.setupAnimations();
  }

  private setupAnimations(): void {
    // Animate header
    if (this.header) {
      gsap.from(this.header.children, {
        opacity: 0,
        y: 30,
        duration: 0.8,
        stagger: 0.2,
        scrollTrigger: {
          trigger: this.header,
          start: 'top 80%',
          end: 'top 20%',
          toggleActions: 'play none none none',
        },
      });
    }

    // Animate cards
    if (this.cards.length > 0) {
      this.cards.forEach((card, index) => {
        const image = card.querySelector('.c-column-text-image__card-image-wrapper');
        const content = card.querySelector('.c-column-text-image__card-content');
        const divider = card.querySelector('.c-column-text-image__card-divider');

        // Image animation
        if (image) {
          gsap.from(image, {
            opacity: 0,
            y: 40,
            duration: 0.8,
            scrollTrigger: {
              trigger: card,
              start: 'top 85%',
              end: 'top 20%',
              toggleActions: 'play none none none',
            },
          });
        }

        // Content animation
        if (content) {
          gsap.from(content.children, {
            opacity: 0,
            y: 20,
            duration: 0.6,
            stagger: 0.1,
            delay: 0.2,
            scrollTrigger: {
              trigger: card,
              start: 'top 85%',
              end: 'top 20%',
              toggleActions: 'play none none none',
            },
          });
        }

        // Divider line draw animation
        if (divider) {
          gsap.from(divider, {
            scaleX: 0,
            transformOrigin: 'left',
            duration: 0.8,
            delay: 0.4,
            scrollTrigger: {
              trigger: card,
              start: 'top 85%',
              end: 'top 20%',
              toggleActions: 'play none none none',
            },
          });
        }
      });
    }
  }
}

// Initialize all column text & image sections
document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[data-column-text-image]');
  sections.forEach((section) => {
    new ColumnTextImage(section as HTMLElement);
  });
});

export default ColumnTextImage;

